import { Controller } from "@hotwired/stimulus"
import { resolveView, setView, normalizeView } from "../contact_view"

export default class extends Controller {
    // toggleBtn: the toolbar's one round button (shared/_list_view_toggle) that
    // flips expanded <-> compact, lit while compact - the same look as the task
    // list's fold toggle beside it.
    static targets = ["toggleBtn"]
    static values = {
        view: { type: String, default: "expanded" },
        scope: { type: String, default: "contact" },
        urlParam: { type: String, default: "view" },
        defaultView: { type: String, default: "expanded" }
    }

    connect() {
        this.onViewChange = this.onViewChange.bind(this);
        document.addEventListener("emailpa:contactviewchange", this.onViewChange);

        const url = new URL(window.location.href);
        const urlView = url.searchParams.get(this.urlParamValue);
        const fallback = normalizeView(this.viewValue || this.defaultViewValue);
        const view = resolveView(urlView, this.scopeValue, fallback);
        if (urlView === "compact" || urlView === "expanded") {
            localStorage.setItem(`emailpa-${this.scopeValue}-view`, urlView);
        }
        this.apply(view);
        this.syncUrl(view);
    }

    disconnect() {
        document.removeEventListener("emailpa:contactviewchange", this.onViewChange);
    }

    onViewChange(event) {
        if (event.detail.scope && event.detail.scope !== this.scopeValue) return;
        this.apply(event.detail.view);
    }

    showCompact() {
        this.switch("compact");
    }

    showExpanded() {
        this.switch("expanded");
    }

    toggle() {
        const current = normalizeView(this.element.getAttribute("data-contact-view"));
        this.switch(current === "compact" ? "expanded" : "compact");
    }

    // A frame re-render (filters, paging) brings a fresh button in its default
    // state; match it to the view on screen.
    toggleBtnTargetConnected() {
        this.updateButtons(normalizeView(this.element.getAttribute("data-contact-view")));
    }

    switch(view) {
        setView(view, document, this.scopeValue);
        this.syncUrl(view);
    }

    apply(view) {
        const next = normalizeView(view);
        this.element.setAttribute("data-contact-view", next);
        this.updateButtons(next);
    }

    syncUrl(view) {
        const url = new URL(window.location.href);
        const defaultView = normalizeView(this.defaultViewValue);
        if (view === defaultView) url.searchParams.delete(this.urlParamValue);
        else url.searchParams.set(this.urlParamValue, view);
        window.history.replaceState({}, "", url);
    }

    updateButtons(view) {
        this.toggleBtnTargets.forEach((btn) => {
            const compact = view === "compact";
            const label = compact ? "Expanded view" : "Compact view";
            btn.classList.toggle("is-active", compact);
            btn.setAttribute("aria-pressed", compact ? "true" : "false");
            btn.title = label;
            btn.setAttribute("aria-label", label);
            const icon = btn.querySelector("i");
            if (icon) icon.className = compact ? "bi bi-chevron-expand" : "bi bi-chevron-contract";
        });
    }
}
